
import React, { createContext, useContext, ReactNode } from 'react';
import translations from '@/locales';

// Apenas para tradução, moeda fixa BRL

interface LocaleContextType {
  t: (key: string, fallback?: string, values?: Record<string, any>) => string;
}

const LocaleContext = createContext<LocaleContextType | undefined>(undefined);

// Função de interpolação para as traduções
function interpolate(template: string, values?: Record<string, any>): string {
  if (!values) return template;
  return template.replace(/\{(\w+)\}/g, (_, k) => (values[k] !== undefined ? values[k] : `{${k}}`));
}

export const LocaleProvider = ({ children }: { children: ReactNode }) => {
  // t sempre pega apenas pt-BR agora
  function t(key: string, fallback?: string, values?: Record<string, any>): string {
    const parts = key.split(".");
    let value: any = translations;
    for (const part of parts) {
      if (value?.[part] !== undefined) {
        value = value[part];
      } else {
        value = fallback || key;
        break;
      }
    }
    if (typeof value === "string") {
      return interpolate(value, values);
    }
    return fallback || key;
  }

  return (
    <LocaleContext.Provider value={{
      t
    }}>
      {children}
    </LocaleContext.Provider>
  );
};

export const useLocale = () => {
  const context = useContext(LocaleContext);
  if (context === undefined) {
    throw new Error('useLocale must be used within a LocaleProvider');
  }
  return context;
};
